import React from "react";
import HeroSection from "../../Components/Common/HeroSection";
import CivilCourses from "./Components.jsx/Courses";
import { motion } from "framer-motion";
import { useAuth } from "../../Context/AuthContext";
import NotFound from "../Notfound";

const FeCivil = () => {
  const { categoryData } = useAuth();
  const course = categoryData?.find((item) => item.title === "Civil");

  if (course?.visibility === false) {
    return <NotFound />;
  }
  return (
    <motion.div
      initial={{ opacity: 1, y: -40 }} // Start above the view
      whileInView={{ opacity: 1, y: 0 }} // End at normal position
      transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
    >
      <HeroSection
        title={`Our ${course?.visibleTitle || "FE Civil"} Packages`}
        backgroundImage="https://storage.googleapis.com/road-to-fe/uploads/1741417535659-07d447cd-82a2-4b1b-8c08-9fffeaaefa18-colleagues-doing-team-work-project_23-2149361607.avif"
        subtitle="One Platform Many Options To Explore"
      />
      <CivilCourses />
    </motion.div>
  );
};

export default FeCivil;
